import moment from "moment"
moment.locale('de');

export default {
    methods: {
        formatDateTimeForHuman(value) {
            return moment(value).format('ddd, DD MMM YYYY, HH:mm')
        },
        formatDateForHuman(value) {
            return moment(value).format('ddd, DD MMM YYYY')
        }
    }
}